import axios from "axios"
export function approveAdvertisement(adId, token) {
    if (typeof adId === 'object') {
        return axios.post(process.env.REACT_APP_API_URL + `/approveAdvertisement`, adId, {
            headers: {
                'Authorization': `${token}`
            }
        });
    }
}